import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { CalendarComponentOptions } from 'ion4-calendar';
import * as moment from 'moment';


@Component({
  selector: 'app-month-picker',
  templateUrl: './month-picker.component.html',
  styleUrls: ['./month-picker.component.scss'],
})
export class MonthPickerComponent {

  @Input() tipo: string;
  @Output() selectedDateEvent = new EventEmitter();

  optionsRange: CalendarComponentOptions = {
    monthPickerFormat: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
    weekdays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    monthFormat: 'MMMM YYYY',
    from: new Date(1),
    showMonthPicker: true,
  };

  constructor(
    private poopverCtrl: PopoverController
  ) { 
    moment.locale('pt-br');
  }

  onChange($event) {
    this.poopverCtrl.dismiss($event);
  }


}
